export const GameModes = {
  REAL: 'real',
  FUN: 'fun',
};

Object.freeze(GameModes);